module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIGhlaWdodD0iNDgiIHZpZXdCb3g9IjAgLTk2MCA5NjAgOTYwIiB3aWR0aD0iNDgiPjxwYXRoIGQ9Ik03OTYtMTIxIDUzMy0zODRxLTMwIDI2LTY5Ljk1OSA0MC41VDM3OC0zMjlxLTEwOC4xNjIgMC0xODMuMDgxLTc1UTEyMC00NzkgMTIwLTU4NXQ3NS0xODFxNzUtNzUgMTgxLjUtNzV0MTgxIDc1UTYzMi02OTEgNjMyLTU4NC44NSA2MzItNTQyIDYxOC01MDJxLTE0IDQwLTQyIDc1bDI2NCAyNjItNDQgNDRaTTM3Ny0zODlxODEuMjUgMCAxMzguMTI1LTU3LjVUNTcyLTU4NXEwLTgxLTU2Ljg3NS0xMzguNVQzNzctNzgxcS04Mi4wODMgMC0xMzkuNTQyIDU3LjVRMTgwLTY2NiAxODAtNTg1dDU3LjQ1OCAxMzguNVEyOTQuOTE3LTM4OSAzNzctMzg5WiIvPjwvc3ZnPg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/search.svg
// module id = 0Vgq
// module chunks = 0